import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { CTRangeInputSetting } from '../../../service/recordview-param';

@Component({
	selector: 'common-range-input-setting',
	templateUrl: './range-input-setting.component.html',
	styleUrls: ['./range-input-setting.component.scss']
})
export class RangeInputSettingComponent implements OnInit {
	@HostBinding('class.range-input-setting') hostClass = true;
	@Input() data: CTRangeInputSetting;
	constructor() {}

	ngOnInit() {}
}
